var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedInIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.583h-2.277V12.01c0-.852-.017-1.948-1.186-1.948-1.185 0-1.366.928-1.366 1.887v3.634H9.39V8.237h2.187v1.001h.031c.305-.576 1.049-1.186 2.158-1.186 2.307 0 2.733 1.521 2.733 3.501v4.03zM6.822 7.23A1.322 1.322 0 015.5 5.906a1.322 1.322 0 112.642 0c0 .731-.592 1.324-1.32 1.324zM5.68 15.583h2.28V8.237H5.68v7.346z",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default SvgLinkedInIcon;